"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
var apollo_client_1 = require("apollo-client");
var apollo_link_http_1 = require("apollo-link-http");
var Crypto = require("crypto");
var node_fetch_1 = require("node-fetch");
var queries_1 = require("./queries");
var CryptobadgeClient = /** @class */ (function (_super) {
    __extends(CryptobadgeClient, _super);
    function CryptobadgeClient(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.url =
            options.url ||
                process.env.CRYPTOBADGE_API_URL ||
                "https://api.cryptobadge.xyz/api";
        _this.accessToken = (function () {
            var accessToken = options.accessToken || process.env.CRYPTOBADGE_ACCESS_TOKEN;
            if (!accessToken) {
                throw new Error("CRYPTOBADGE_ACCESS_TOKEN is required");
            }
            return accessToken;
        })();
        _this.authorizationKey =
            options.authorizationKey ||
                process.env.CRYPTOBADGE_AUTHORIZATION_KEY ||
                null;
        var headers = {
            "x-cryptobadge-access-token": _this.accessToken,
        };
        if (_this.authorizationKey) {
            headers["x-cryptobadge-authorization"] = _this.authorizationKey;
        }
        var postHttpLink = apollo_link_http_1.createHttpLink({
            fetch: node_fetch_1.default,
            headers: headers,
            uri: _this.url,
        });
        _this._queryClient = new apollo_client_1.ApolloClient({
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            link: postHttpLink,
        });
        _this._mutationClient = new apollo_client_1.ApolloClient({
            cache: new apollo_cache_inmemory_1.InMemoryCache(),
            link: postHttpLink,
        });
        return _this;
    }
    Object.defineProperty(CryptobadgeClient.prototype, "queryClient", {
        get: function () {
            if (process.env.STAGE === "test")
                return this._mutationClient;
            return this._queryClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CryptobadgeClient.prototype, "mutationClient", {
        get: function () {
            return this._mutationClient;
        },
        enumerable: true,
        configurable: true
    });
    CryptobadgeClient.prototype.encryptEmail = function (email) {
        if (this.authorizationKey === null) {
            throw new Error("CRYPTOBADGE_SECRET_KEY is required");
        }
        var cipher = Crypto.createCipheriv("aes-256-cbc", this.authorizationKey, Buffer.alloc(16));
        var encryptedMsg = cipher.update(email, "utf8", "base64") + cipher.final("base64");
        return encryptedMsg.toString();
    };
    return CryptobadgeClient;
}(queries_1.Queries));
exports.CryptobadgeClient = CryptobadgeClient;
//# sourceMappingURL=client.js.map